import { render, staticRenderFns } from "./BottomRightBar.vue?vue&type=template&id=6527cb11&scoped=true"
import script from "./BottomRightBar.vue?vue&type=script&lang=js"
export * from "./BottomRightBar.vue?vue&type=script&lang=js"
import style0 from "./BottomRightBar.vue?vue&type=style&index=0&id=6527cb11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6527cb11",
  null
  
)

export default component.exports